import {
  BuyerSurveyResponse,
  EachSupplier,
  GetSupplierBlendInterface,
  SubSupplierGroup,
  SupplierResponseInterface,
} from '../../shared/interfaces/survey.interface';

export class SupplierBlendAlerts {
  appliedBlendId: string;
  surveyDetails: BuyerSurveyResponse | undefined;
  supplierBlendData: GetSupplierBlendInterface[];
  selectedBlend: any;
  suppliers: SupplierResponseInterface[];

  constructor(
    appliedBlendId: string | undefined,
    surveyDetails: BuyerSurveyResponse | undefined,
    supplierBlendData: GetSupplierBlendInterface[],
    selectedBlend: EachSupplier | any,
    suppliers: SupplierResponseInterface[] | undefined
  ) {
    this.appliedBlendId = appliedBlendId || '';
    this.surveyDetails = surveyDetails;
    this.supplierBlendData = supplierBlendData;
    this.selectedBlend = selectedBlend;
    this.suppliers = suppliers || [];
  }

  isDefaultBlendNotApplied() {
    if (
      this.appliedBlendId ||
      this.appliedBlendId === this.surveyDetails?.blend_id
    ) {
      return false;
    }

    const defaultBlend = this.supplierBlendData.find(
      (blend) => blend.is_default
    );
    if (
      defaultBlend?.id &&
      this.surveyDetails?.hasOwnProperty('blend_applied') &&
      !this.surveyDetails?.blend_applied
    ) {
      return true;
    }
    return false;
  }

  thereIsMissMatchSuppliers(): boolean {
    if (
      this.appliedBlendId ||
      this.appliedBlendId === this.surveyDetails?.blend_id
    ) {
      return false;
    }

    const blendsWithAllocation = this._removeZeroAllocationSuppliers(
      this.selectedBlend
    );

    const blendsSupplierIds = blendsWithAllocation.flatMap(
      ({ supplier_id }: EachSupplier) =>
        supplier_id.map(({ id }: SubSupplierGroup) => id)
    );
    const supplierIds =
      this.suppliers?.flatMap(({ suppliers }) =>
        suppliers.map(({ id }) => id)
      ) || [];

    if (blendsSupplierIds.length === 0 || supplierIds.length === 0) {
      return false;
    }

    const difference = blendsSupplierIds.filter(
      (id: number) => !supplierIds.includes(id)
    );
    if (difference.length > 0) {
      return true;
    }
    return false;
  }

  private _removeZeroAllocationSuppliers(selectedBlend: EachSupplier | any) {
    if (!selectedBlend || !selectedBlend.suppliers) {
      return [];
    }
    return selectedBlend.suppliers.filter(
      (supplier: any) => supplier.allocation_percentage != '0'
    );
  }
}
